export default {
      id: "viewMoreHorizontal-usage",
      viewBox: "0 0 16 4",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#viewMoreHorizontal",
      toString: function () {
        return this.url;
      }
    }